<nb-card>
  <nb-card-header>
    <div i18n="@@ContactAndBillingInfo" class="title">
      Contact and Billing Info
    </div>
  </nb-card-header>

  <nb-card-body [nbSpinner]="isLoading">
    <div [formGroup]="userForm">
      <div class="row">
        <div class="col-md-6">
          <nb-card>
            <nb-card-header>
              <ng-container i18n="@@ContactInfo">Contact Info</ng-container>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <label
                  i18n="@@FirstName"
                  for="firstName"
                  class="col-sm-4 col-form-label"
                  >First Name</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    id="firstName"
                    autofocus
                    fullWidth
                    formControlName="firstName"
                    [status]="
                      firstName?.hasError('minlength') ||
                      firstName?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    i18n-placeholder="@@FirstName"
                    placeholder="First Name"
                  />
                  <ngx-validation-message
                    i18n-label="@@FirstName"
                    label="First Name"
                    [showMinLength]="firstName?.hasError('minlength')"
                    [showMaxLength]="firstName?.hasError('maxlength')"
                    minLength="3"
                    maxLength="40"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <label
                  i18n="@@LastName"
                  for="lastName"
                  class="col-sm-4 col-form-label"
                  >Last Name</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    id="lastName"
                    fullWidth
                    formControlName="lastName"
                    [status]="
                      lastName?.hasError('minlength') ||
                      lastName?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    class="form-control"
                    i18n-placeholder="@@LastName"
                    placeholder="Last Name"
                  />
                  <ngx-validation-message
                    i18n-label="@@LastName"
                    label="Last Name"
                    [showMinLength]="lastName?.hasError('minlength')"
                    [showMaxLength]="lastName?.hasError('maxlength')"
                    minLength="3"
                    maxLength="40"
                  ></ngx-validation-message>
                </div>
              </div>

              <!-- <div class="form-group row">
                <label i18n="@@Account" for="inputLogin" class="col-sm-4 col-form-label">Account</label>
                <div class="col-sm-8">
                  <input nbInput id="inputLogin" readonly fullWidth [value]="currentUser?.login"
                         [status]="(login?.errors?.required || login?.hasError('minlength') || login?.hasError('maxlength')) && login.touched ? 'danger' : 'primary'"
                         class="form-control" i18n-placeholder="@@Login" placeholder="Login">
                  <ngx-validation-message i18n-label="@@Login" label="Login"
                                          [showMinLength]="login?.hasError('minlength')"
                                          [showMaxLength]="login?.hasError('maxlength')"
                                          [showRequired]="login?.errors?.required && login.touched"
                                          minLength=6
                                          maxLength=20></ngx-validation-message>
                </div>
              </div> -->

              <div class="form-group row">
                <label
                  i18n="@@Email"
                  for="inputEmail"
                  class="col-sm-4 col-form-label"
                  >Email</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    id="inputEmail"
                    fullWidth
                    formControlName="email"
                    class="form-control"
                    i18n-placeholder="@@Email"
                    placeholder="Email"
                  />
                  <!-- <ngx-validation-message i18n-label="@@Email" label="Email"
                                          [showPattern]="email?.hasError('pattern') && email.touched"
                                          [showRequired]="email?.errors?.required && email.touched" min=1 max=120></ngx-validation-message> -->
                </div>
              </div>

              <div class="form-group row">
                <label
                  i18n="@@PhoneNumber"
                  for="inputPhonenumber"
                  class="col-sm-4 col-form-label"
                  >Phone Number</label
                >
                <div class="col-sm-8">
                  <ngx-intl-tel-input
                    [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name
                    ]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.UnitedStates"
                    [maxLength]="15"
                    [numberFormat]="PhoneNumberFormat.International"
                    [phoneValidation]="true"
                    name="phoneNumber"
                    formControlName="phoneNumber"
                    shape="semi-round"
                  ></ngx-intl-tel-input>
                  <ngx-validation-message
                    i18n-label="@@PhoneNumber"
                    label="Mobile Number"
                    [showRequired]="
                      phoneNumber?.errors?.required && phoneNumber.touched
                    "
                    [showPattern]="
                      !phoneNumber?.errors?.required &&
                      phoneNumber?.invalid &&
                      phoneNumber.touched
                    "
                    min="10"
                    max="15"
                  ></ngx-validation-message>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="conversionFactorsPreference"
                  class="col-sm-4 col-form-label"
                  >Conversion factor preference</label
                >
                <div class="col-sm-8">
                  <nb-select
                    id="conversionFactorsPreference"
                    size="medium"

                    placeholder="Conversion Factor Preference"
                    fullWidth
                    formControlName="conversionFactorsPreference"
                  >
                    <nb-option
                      *ngFor="let item of ConversionFactorsPreference"
                      [value]="item.value"
                      >{{ item.text }}</nb-option
                    >
                  </nb-select>
                  </div>
                </div>

            </nb-card-body>
          </nb-card>
        </div>

        <div class="col-md-6">
          <nb-card>
            <nb-card-header>
              <ng-container i18n="@@BillingInfo">Billing Info</ng-container>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <label
                  i18n="@@BusinessName"
                  for="inputBusinessName"
                  class="col-sm-4 col-form-label"
                  >Business Name</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    class="form-control"
                    id="inputBusinessName"
                    [status]="
                      businessName?.errors?.required ||
                      businessName?.hasError('minlength') ||
                      businessName?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    i18n-placeholder="@@BusinessName"
                    placeholder="Business Name"
                    formControlName="businessName"
                  />
                  <ngx-validation-message
                    i18n-label="@@BusinessName"
                    label="Business Name"
                    [showRequired]="
                      businessName?.errors?.required && businessName.touched
                    "
                    [showMinLength]="businessName?.hasError('minlength')"
                    [showMaxLength]="businessName?.hasError('maxlength')"
                    minLength="3"
                    maxLength="100"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row" formGroupName="address">
                <label
                  i18n="@@Address"
                  for="inputStreet"
                  class="col-sm-4 col-form-label"
                  >Address</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    class="form-control"
                    id="inputStreet"
                    [status]="
                      street?.errors?.required ||
                      street?.hasError('minlength') ||
                      street?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    i18n-placeholder="@@Address"
                    placeholder="Address"
                    formControlName="street"
                  />
                  <ngx-validation-message
                    i18n-label="@@Address"
                    label="Address"
                    [showRequired]="street?.errors?.required && street.touched"
                    [showMinLength]="street?.hasError('minlength')"
                    [showMaxLength]="street?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row" formGroupName="address">
                <div class="col-sm-4 col-form-label"></div>
                <div class="col-sm-8">
                  <input
                    nbInput
                    class="form-control"
                    id="secondAddress"
                    i18n-placeholder="@@SecondAddress"
                    placeholder="2nd Address"
                    formControlName="secondAddress"
                  />
                </div>
              </div>

              <div class="form-group row" formGroupName="address">
                <label
                  i18n="@@City"
                  for="inputCity"
                  class="col-sm-4 col-form-label"
                  >City</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    class="form-control"
                    id="inputCity"
                    [status]="
                      city?.errors?.required ||
                      city?.hasError('minlength') ||
                      city?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    i18n-placeholder="@@City"
                    placeholder="City"
                    formControlName="city"
                  />
                  <ngx-validation-message
                    i18n-label="@@City"
                    label="City"
                    [showRequired]="city?.errors?.required && city.touched"
                    [showMinLength]="city?.hasError('minlength')"
                    [showMaxLength]="city?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row" formGroupName="address">
                <label
                  i18n="@@Country"
                  for="inputCountry"
                  class="col-sm-4 col-form-label"
                  >Country</label
                >
                <div class="col-sm-8">
                  <nb-select
                    id="inputCountry"
                    size="medium"
                    i18n-placeholder="@@Country"
                    placeholder="Country"
                    fullWidth
                    [status]="
                      country?.errors?.required ||
                      country?.hasError('minlength') ||
                      country?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    formControlName="country"
                  >
                    <nb-option
                      *ngFor="let item of Countries | async"
                      [value]="item.name"
                      >{{ item.name }}</nb-option
                    >
                  </nb-select>
                  <ngx-validation-message
                    i18n-label="@@Country"
                    label="Country"
                    [showRequired]="
                      country?.errors?.required && country.touched
                    "
                    [showMaxLength]="country?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row" formGroupName="address">
                <label
                  i18n="@@ZipCode"
                  for="inputZipCode"
                  class="col-sm-4 col-form-label"
                  >Zip Code</label
                >
                <div class="col-sm-8">
                  <input
                    nbInput
                    class="form-control"
                    id="inputZipCode"
                    i18n-placeholder="@@ZipCode"
                    placeholder="Zip Code"
                    formControlName="zipCode"
                  />
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="row" *ngIf="isAdmin">
        <div class="col-md-6">
          <!-- <nb-card>
            <nb-card-header>
              App Settings
            </nb-card-header>
            <nb-card-body>
              <div *ngIf="appSettings?.apkUrl">
                <a [href]="appSettings.apkUrl" target="_blank">Download APK</a>
              </div>
              <div *ngIf="appSettings?.ipaUrl">
                <a [href]="appSettings.ipaUrl" target="_blank">Download IPA</a>
              </div>
              <button nbButton (click)="runBuild()">Run Build</button>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Is Custom App In Production</label>
                <div class="col-sm-8">
                  <nb-toggle [checked]="isCustomAppInProduction" (checkedChange)="changeIsCustomAppInProduction($event)"></nb-toggle>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Is Custom App enabled</label>
                <div class="col-sm-8">
                  <nb-toggle [checked]="isCustomAppEnabled" (checkedChange)="changeCustomAppEnabled($event)"></nb-toggle>
                </div>
              </div>

              <div class="form-group row" *ngIf="userSettings">
                <label class="col-sm-4 col-form-label">App Store url</label>
                <div class="col-sm-8">
                  <input nbInput type="text" [(ngModel)]="userSettings.appStoreUrl" [ngModelOptions]="{standalone: true}"/>
                </div>
              </div>
              <div class="form-group row"  *ngIf="userSettings">
                <label class="col-sm-4 col-form-label">Play store url</label>
                <div class="col-sm-8">
                  <input nbInput type="text"  [(ngModel)]="userSettings.playStoreUrl" [ngModelOptions]="{standalone: true}"/>
                </div>
              </div>

                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">App Store Password</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.appStorePassword" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Key ID</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.keyId" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Issuer ID</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.issuerId" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Username</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.username" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Team ID</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.teamId" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Team Name</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.teamName" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Bundle ID</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.bundleId" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Branch Name</label>
                  <div class="col-sm-8">
                    <input nbInput type="text" [(ngModel)]="configurations.branchName" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">
                    tokenFileUpload
                  </label>
                  <div class="col-sm-8">
                    <input nbInput type="file" accept="*.p8" (change)="tokenFileUpload($event)"/>
                  </div>
                </div>
            </nb-card-body>
          </nb-card> -->
          <app-settings *ngIf="currentUser" (userSettingsChange)="saveAppSettings($event)" [user]="currentUser" [userSettings]="currentUser.settings"></app-settings>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      i18n="@@Submit"
      nbButton
      class="btn-circle btn-xl btn-main"
      [disabled]="!userForm.valid || isLoading"
      (click)="save()"
    >
      Submit
    </button>
  </nb-card-footer>
</nb-card>

<nb-card *ngIf="mode === UserFormMode.EDIT_SELF">
  <nb-card-header>
    <div i18n="@@ChangePassword" class="title">Change Password</div>
  </nb-card-header>

  <nb-card-body [nbSpinner]="isLoading">
    <div
      [formGroup]="resetPasswordForm"
      aria-labelledby="title"
      class="limits-width"
    >
      <div class="form-group">
        <label i18n="@@CurrentPassword" for="current-password"
          >Current Password</label
        >
        <input
          nbInput
          fullWidth
          id="current-password"
          formControlName="currentPassword"
          type="password"
          [status]="
            currentPassword.dirty
              ? currentPassword.invalid
                ? 'danger'
                : 'success'
              : ''
          "
          class="form-control"
          i18n-placeholder="@@CurrentPassword"
          placeholder="Current Password"
        />
        <ngx-validation-message
          i18n-label="@@CurrentPassword"
          label="Current Password"
          [showMinLength]="
            currentPassword?.hasError('minlength') && currentPassword.touched
          "
          [showMaxLength]="
            currentPassword?.hasError('maxlength') && currentPassword.touched
          "
          [showRequired]="
            currentPassword?.errors?.required && currentPassword.touched
          "
          [minLength]="minLength"
          [maxLength]="maxLength"
        ></ngx-validation-message>
      </div>

      <div class="form-group">
        <label i18n="@@NewPassword" for="new-password">New Password</label>
        <input
          nbInput
          fullWidth
          id="new-password"
          formControlName="Password"
          type="password"
          [status]="
            Password.dirty ? (Password.invalid ? 'danger' : 'success') : ''
          "
          class="form-control"
          i18n-placeholder="@@NewPassword"
          placeholder="New Password"
        />
        <ngx-validation-message
          i18n-label="@@NewPassword"
          label="New Password"
          [showMinLength]="Password?.hasError('minlength') && Password.touched"
          [showMaxLength]="Password?.hasError('maxlength') && Password.touched"
          [showRequired]="Password?.errors?.required && Password.touched"
          [minLength]="minLength"
          [maxLength]="maxLength"
        ></ngx-validation-message>
      </div>

      <div class="form-group">
        <label i18n="@@ConfirmPassword" for="input-re-password"
          >ConfirmPassword</label
        >
        <input
          nbInput
          fullWidth
          id="input-re-password"
          formControlName="confirmPassword"
          type="password"
          class="form-control"
          [status]="
            confirmPassword.dirty
              ? confirmPassword.invalid ||
                Password.value != confirmPassword.value
                ? 'danger'
                : 'success'
              : ''
          "
          i18n-placeholder="@@ConfirmPassword"
          placeholder="{{ ConfirmPasswordLabel }}"
        />
        <ngx-validation-message
          i18n-label="@@ConfirmPassword"
          label="{{ ConfirmPasswordLabel }}"
          [showMinLength]="
            confirmPassword?.hasError('minlength') && confirmPassword.touched
          "
          [showMaxLength]="
            confirmPassword?.hasError('maxlength') && confirmPassword.touched
          "
          [showRequired]="
            confirmPassword?.errors?.required && confirmPassword.touched
          "
          [minLength]="minLength"
          [maxLength]="maxLength"
        ></ngx-validation-message>
        <p
          class="error-message caption status-danger"
          *ngIf="
            Password.value != confirmPassword.value && confirmPassword.touched
          "
        >
          <ng-container i18n="@@NewPasswordConfirmPasswordMismatch"
            >New password and confirm password does not match!
          </ng-container>
        </p>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      i18n="@@ChangePassword"
      nbButton
      class="btn-circle btn-xl btn-main"
      (click)="changePassword()"
      [disabled]="
        !resetPasswordForm.valid || Password.value != confirmPassword.value || isLoading
      "
    >
      Change Password
    </button>
  </nb-card-footer>
</nb-card>
